/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="127.95"
        height="68.94"
        viewBox="0 0 127.95 68.94"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M61.84 47.49a1.23 1.23 0 0 1 1.64.27l.08.11 7.86 12.32a4.21 4.21 0 0 0 5.78 1.43 4.4 4.4 0 0 0 1.64-5.61 1.252 1.252 0 1 1 2.14-1.3l.06.12a6.88 6.88 0 0 1-2.58 9 6.72 6.72 0 0 1-9-2.08l-.13-.2-7.88-12.36a1.25 1.25 0 0 1 .39-1.7Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M52.99 54.11a1.24 1.24 0 0 1 1.65.27l.08.11 5 7.89a4.21 4.21 0 0 0 5.77 1.43 4.39 4.39 0 0 0 1.65-5.61 1.27 1.27 0 0 1 .6-1.67 1.25 1.25 0 0 1 1.6.49 6.87 6.87 0 0 1-2.58 8.95 6.72 6.72 0 0 1-9-2.08l-.13-.2-5-7.85a1.26 1.26 0 0 1 .36-1.73ZM64.06 2.41a1.25 1.25 0 1 1 0 2.5 8.8 8.8 0 0 0-6.77 3.14l-.19.23-12.89 16.83a4.77 4.77 0 0 0-1 2.89 4.87 4.87 0 0 0 4.88 4.84 4.9 4.9 0 0 0 3.32-1.29l.19-.18 12.09-12.26a3.19 3.19 0 0 1 2.24-.89h.28l3.5.32 2.13.18h.75a4.48 4.48 0 0 1 3.52 2.23l.11.2 16.8 32a6.9 6.9 0 0 1-2.59 9 6.73 6.73 0 0 1-9-2.08l-.12-.21-11-17.26a1.25 1.25 0 0 1 2-1.45l.08.11 11 17.3a4.23 4.23 0 0 0 5.78 1.43 4.43 4.43 0 0 0 1.73-5.43l-.11-.23-16.79-32a2 2 0 0 0-1.44-1.06h-.16l-2-.16-4.4-.4h-.06a.79.79 0 0 0-.42.12l-.08.06-12 12.22A7.39 7.39 0 0 1 40.78 28a7.21 7.21 0 0 1 1.3-4.15l.18-.26 12.9-16.86a11.28 11.28 0 0 1 8.9-4.32Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M64.06 2.41h18.26a8.27 8.27 0 0 1 2.92.51l.36.13 18.56 8.04a1.25 1.25 0 0 1-.88 2.34h-.12l-18.48-8a5.93 5.93 0 0 0-2-.44H64.07a1.27 1.27 0 0 1-1.25-1.26 1.25 1.25 0 0 1 1.12-1.24ZM47.52 6.25a32.42 32.42 0 0 1 8.09 1 1.25 1.25 0 1 1-.47 2.45H55a30.5 30.5 0 0 0-6.79-.92H24.57a1.25 1.25 0 0 1-.13-2.49h23.08ZM31.48 44.35a6.75 6.75 0 0 1 5.56 2.92l.15.22 10.82 16.92a4.23 4.23 0 0 0 5.78 1.43 4.38 4.38 0 0 0 1.63-5.62 1.26 1.26 0 0 1 .56-1.69 1.25 1.25 0 0 1 1.65.51 6.9 6.9 0 0 1-2.58 9 6.72 6.72 0 0 1-9-2.07l-.13-.21-10.76-16.93a4.25 4.25 0 0 0-3.37-2h-7.14a1.25 1.25 0 0 1-.13-2.49h7ZM103.78 50.47a1.25 1.25 0 0 1 1.23 1.27 1.27 1.27 0 0 1-1.1 1.22h-13a1.26 1.26 0 0 1-1.29-1.22 1.25 1.25 0 0 1 1.16-1.28h13Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M24.16 0a1.24 1.24 0 0 1 1.24 1.12v51.36a1.27 1.27 0 0 1-1.13 1.25h-23a1.25 1.25 0 0 1-.13-2.49h21.73V2.5H1.38A1.27 1.27 0 0 1 .16 1.41v-.13A1.24 1.24 0 0 1 1.28.04h22.88Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M14.43 40.56a3.66 3.66 0 1 1-3.66-3.66 3.64 3.64 0 0 1 3.66 3.64"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M10.78 35.65a4.91 4.91 0 1 0 4.91 4.91 4.91 4.91 0 0 0-4.91-4.91Zm0 2.5a2.41 2.41 0 1 1-2.41 2.41 2.4 2.4 0 0 1 2.41-2.37Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M126.59 4.41a1.252 1.252 0 0 1 .13 2.5h-21.56v48.74h21.6a1.23 1.23 0 0 1 1.24 1.12v.13a1.25 1.25 0 0 1-1.12 1.24h-23a1.26 1.26 0 0 1-1.24-1.13V5.66a1.25 1.25 0 0 1 1.12-1.24h22.88Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M120.78 44.59a3.66 3.66 0 1 1-3.66-3.66 3.66 3.66 0 0 1 3.66 3.66"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M117.16 39.68a4.92 4.92 0 1 0 4.91 4.93 4.91 4.91 0 0 0-4.91-4.91Zm0 2.5a2.42 2.42 0 1 1-2.38 2.46v-.05a2.4 2.4 0 0 1 2.38-2.4Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'HandshakeIcon';

export default Icon;
